import React from "react";
import Card from "react-bootstrap/Card";
import { Col, Row } from "react-bootstrap";


function Techstack() {
  const values = [
    {
      text: "We believe equity is achieved by valuing all voices, fostering inclusion, and empowering individuals to contribute to community well-being.",
    },
    {
      text: "We create supportive spaces for youth and adults to belong, connect personal growth with social change, and inspire collaboration to tackle shared challenges.",
    },
    {
      text: "We are dedicated to fairness and equality, working to dismantle systemic barriers and ensure everyone has the opportunity to thrive.",
    },
    {
      text: "We believe meaningful change occurs when we create equitable opportunities for individuals while also addressing the systemic challenges that impact our world.",
    },
    {
      text: "We value collaboration as a skill that empowers individuals to work effectively across cultures, navigate team dynamics, and foster mutual learning and growth.",
    },
  ];

  return (
    <Row className="mission-values">
      {values.map((value, index) => (
        <Col key={index} xs={12} md={6} lg={4} className="mission-values-col">
          <Card className="policy-card mission-value-card">
            <Card.Body>
              <blockquote className="blockquote mb-0">
                <p className="about-text mission-value-text">{value.text}</p>
              </blockquote>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
